export default __webpack_public_path__ + "assets/1a74fc3e71ef4fbbb45a9a18cba059a1.svg";